import React from "react";
import { useSelector } from "react-redux";
import { NavLink, Outlet } from "react-router-dom";
import "./Activity.css";

const activityPage = () => {
  const role = useSelector((store) => store.userReducer.role);
  return (
    <>
    <h2>
      Activity
    </h2>
      {/* {(role == "super" || role == "operation") && ( */}
        <nav className="navbar-activity">
          <div className="nav-links-activity">
            <NavLink to="/activity/change-status"  className={({ isActive }) => (isActive ? 'active-tab' : '')}>
              Change Status
            </NavLink>
            <NavLink to="/activity/blocked-user"  className={({ isActive }) => (isActive ? 'active-tab' : '')}>
              Blocked User
            </NavLink>
            <NavLink to="/activity/raw-webhook"  className={({ isActive }) => (isActive ? 'active-tab' : '')}>
              Raw Webhook
            </NavLink>
            <NavLink to="/activity/notFound-webhook"  className={({ isActive }) => (isActive ? 'active-tab' : '')}>
              404-Webhook
            </NavLink>
            <NavLink to="/activity/change-password"  className={({ isActive }) => (isActive ? 'active-tab' : '')}>
              Change Password
            </NavLink>
             <NavLink to="/activity/block-keyword"  className={({ isActive }) => (isActive ? 'active-tab' : '')}>
              Add & Block Keyword
            </NavLink>
          </div>
        </nav>
        <div>
            <Outlet/>
        </div>
      {/* )} */}
    </>
  );
};

export default activityPage;
